import React from 'react';
import styled from 'styled-components';

const AboutUs = () => {
  return (
    <Wrapper>
      <div className="content-box">
        <h2>About Us</h2>

        <h4>Welcome to BakPoket — Your Pocket-Friendly Shopping Partner!</h4>
        <p>
          At Bakpoket ("we," "us," or "our"), we are committed to protecting your privacy. This Privacy
          Policy explains how we collect, use, disclose, and safeguard your personal information when
          you visit our website, <a href='https://bakpoket.com/' target="_blank" rel="noopener noreferrer">bakpoket.com</a> or use our services. By using the
          Website, you agree to the practices described in this Privacy Policy. If you do not agree,
          please do not use the Website.
        </p>

        <h4>What We Do</h4>
        <p>
          We curate the latest coupons, cashback deals, and shopping offers across your favorite brands
          and stores — all in one place. No more switching between tabs or missing out on hidden discounts.
          With BakPoket, you shop smarter and save more, every time.
        </p>

        <h4>Who We Serve</h4>
        <p>
          Our platform is built for online shoppers who love great deals, and for merchants looking to
          reach savvy buyers. We bridge the gap between customers and sellers, creating a win-win for
          everyone involved.
        </p>

        <h4>Why Choose BakPoket?</h4>
        <ul>
          <li>Thousands of up-to-date deals from top retailers</li>
          <li>Real cashback on your purchases</li>
          <li>Easy-to-use platform for browsing offers</li>
          <li>Trusted by users and merchants alike</li>
        </ul>

        <h4>Our Promise</h4>
        <p>
          We're not just a coupon site — we're your shopping companion. We believe that saving money
          should be simple, transparent, and rewarding. That’s why we’re constantly updating our deals
          and expanding our network of merchant partners.
        </p>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  background-color: #e6e6e6;
  padding: 40px 16px;
  display: flex;
  justify-content: center;

  .content-box {
    width: 100%;
    max-width: 1200px;
    background-color: #ffffff;
    padding: 40px;
    border-radius: 10px;
    line-height: 1.7;
    color: #333;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    font-size: 1rem;
  }

  h2 {
    margin-bottom: 20px;
    font-size: 2rem;
    font-weight: 600;
  }

  h4 {
    margin-top: 30px;
    margin-bottom: 10px;
    color: #444;
    font-size: 1.2rem;
  }

  ul {
    margin-left: 20px;
    padding-left: 20px;
    list-style: disc;
  }

  li {
    margin-bottom: 10px;
  }

  a {
    color: #ef4766;
    text-decoration: none;
    font-weight: 500;
  }

  @media (max-width: 768px) {
    .content-box {
      padding: 25px;
      font-size: 0.95rem;
    }

    h2 {
      font-size: 1.6rem;
    }

    h4 {
      font-size: 1.1rem;
    }
  }

  @media (max-width: 480px) {
    padding: 10px 16px 40px;
    .content-box {
      padding: 20px;
      font-size: 0.9rem;
    }

    h2 {
      font-size: 1.3rem;
    }

    h4 {
      font-size: 1rem;
    }

    ul {
      margin-left: 15px;
    }
  }
`;

export default AboutUs;
